import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useNavigate } from 'react-router-dom';
import NriBuddyChatbot from '../pages/Chatbot';

const { FiHome, FiShield, FiTool, FiEye, FiDollarSign, FiUsers, FiCheckCircle, FiArrowRight, FiCalendar, FiPhone, FiCamera } = FiIcons;



const PropertyCare = () => {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false); // State to control chatbot modal visibility

  const toggleChatbot = () => {
    setIsChatbotOpen(!isChatbotOpen);
  };
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };
  
  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };
    useEffect(() =>{
      const timer = setInterval(handleNext, 4000);
      return () => clearInterval(timer);
    })
  
    const getPosition = (index) => {
      const total = services.length;
      const leftIndex = (currentIndex - 1 + total) % total;
      const rightIndex = (currentIndex + 1) % total;
      if (index === currentIndex) return 'active';
      if (index === leftIndex) return 'left';
      if (index === rightIndex) return 'right';
      return '';
    };
  const navigate = useNavigate();

  const services = [
    {
      icon: FiEye,
      title: 'Regular Inspections',
      description: 'Monthly property inspections with detailed photo reports',
      features: ['Exterior & interior checks', 'Detailed photo documentation', 'Issue identification', 'Maintenance recommendations']
    },
    {
      icon: FiTool,
      title: 'Maintenance Coordination',
      description: 'Professional maintenance and repair services',
      features: ['Plumbing & electrical', 'Painting & cleaning', 'Garden maintenance', 'Appliance servicing']
    },
    {
      icon: FiShield,
      title: 'Security Monitoring',
      description: '24/7 security monitoring and emergency response',
      features: ['Security system monitoring', 'Emergency response', 'Neighbor coordination', 'Police liaison']
    },
    {
      icon: FiDollarSign,
      title: 'Utility Management',
      description: 'Complete utility bill management and payments',
      features: ['Electricity bill payments', 'Water bill management', 'Internet & cable bills', 'Property tax assistance']
    },
    {
      icon: FiUsers,
      title: 'Tenant Management',
      description: 'Complete tenant screening and management services',
      features: ['Tenant screening', 'Rent collection', 'Lease management', 'Dispute resolution']
    },
    {
      icon: FiPhone,
      title: 'Emergency Support',
      description: '24/7 emergency response and coordination',
      features: ['Natural disaster response', 'Break-in response', 'Utility emergencies', 'Medical emergencies']
    }
  ];

  const testimonials = [
    {
      name: 'Amit Sharma',
      location: 'London, UK',
      property: 'Mumbai Apartment',
      text: 'The peace of mind knowing my property is well-maintained is priceless. The monthly reports are detailed and the team is very responsive.',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
    },
    {
      name: 'Amit Sharma',
      location: 'London, UK',
      property: 'Mumbai Apartment',
      text: 'The peace of mind knowing my property is well-maintained is priceless. The monthly reports are detailed and the team is very responsive.',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
    },
    {
      name: 'Priya Patel',
      location: 'Toronto, Canada',
      property: 'Delhi Villa',
      text: 'Excellent service! They caught a plumbing issue before it became a major problem. The tenant management service has been fantastic.',
      image: 'https://images.unsplash.com/photo-1494790108755-2616b612b77c?w=150&h=150&fit=crop&crop=face'
    }
  ];

  const recentUpdates = [
    {
      property: 'Mumbai Apartment - A-101',
      update: 'Monthly inspection completed',
      date: '2024-01-10',
      status: 'completed',
      images: 3
    },
    {
      property: 'Delhi Villa - B-205',
      update: 'AC maintenance scheduled',
      date: '2024-01-15',
      status: 'scheduled',
      images: 0
    },
    {
      property: 'Bangalore House - C-301',
      update: 'Tenant rent collected',
      date: '2024-01-12',
      status: 'completed',
      images: 1
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 to-primary-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiHome} className="text-4xl text-primary-600" />
            </div>
            <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-semibold bg-primary-50 text-primary-700 border border-primary-200 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              Pay as you choose the service
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Property Care Services
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Complete property management and maintenance services for your homes in India. 
              We ensure your property is well-maintained, secure, and ready for your return.
            </p>
            <Link
              to="/login"
              className="bg-primary-600 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-primary-700 transition-colors inline-flex items-center space-x-2"
            >
              <span>Get Started</span>
              <SafeIcon icon={FiArrowRight} className="text-lg" />
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Comprehensive Property Care
            </h2>
            <p className="text-xl text-gray-600">
              Everything you need to keep your property in perfect condition
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 hover:shadow-xl transition-shadow"
              >
                <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mb-4">
                  <SafeIcon icon={service.icon} className="text-2xl text-primary-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center space-x-2 text-sm text-gray-700">
                      <SafeIcon icon={FiCheckCircle} className="text-green-500 text-xs flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              How It Works
            </h2>
            <p className="text-xl text-gray-600">
              Simple, transparent process to secure and maintain your property
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {[
              { step: '1', title: 'Submit Request', description: 'Share details about your property in India and your specific care requirements.' },
              { step: '2', title: 'Property Assessment', description: 'Our local buddy visits the property for a baseline inspection and checklist.' },
              { step: '3', title: 'Custom Action Plan', description: 'We design a tailored maintenance schedule for regular inspections and upkeep.' },
              { step: '4', title: 'Real-time Monitoring', description: 'Receive detailed photo/video reports and status updates via your dashboard.' }
            ].map((step, index) => (
              <motion.div
                key={step.step}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-xl p-6 border border-gray-200 shadow-md text-center hover:shadow-lg transition-shadow"
              >
                <div className="w-16 h-16 bg-primary-500 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                  {step.step}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600 text-sm">{step.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Recent Updates */}
      
      {/* Testimonials */}
            <section className="bg-gray-50 flex justify-center items-center relative overflow-hidden" style={{ height: '650px', paddingTop: '4rem', paddingBottom: '6rem' }}>
              {/* Animated background elements */}
              <motion.div
                animate={{
                  scale: [1, 1.2, 1],
                  rotate: [0, 90, 0],
                }}
                transition={{
                  duration: 20,
                  repeat: Infinity,
                  ease: "linear"
                }}
                className="absolute top-10 right-10 w-64 h-64 bg-blue-100 rounded-full opacity-20 blur-3xl"
              />
              <motion.div
                animate={{
                  scale: [1.2, 1, 1.2],
                  rotate: [0, -90, 0],
                }}
                transition={{
                  duration: 15,
                  repeat: Infinity,
                  ease: "linear"
                }}
                className="absolute bottom-10 left-10 w-64 h-64 bg-purple-100 rounded-full opacity-20 blur-3xl"
              />
      
              <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  className="text-center mb-12"
                >
                  <motion.h2
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="text-3xl font-bold text-gray-900 mb-4"
                  >
                    Property Owners Trust Us
                  </motion.h2>
                  <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                    className="text-xl text-gray-600 max-w-2xl mx-auto"
                  >
                    See what clients say about our property care services
                  </motion.p>
                </motion.div>
      
                {/* 3D Carousel Container */}
                <div className="relative mx-auto" style={{ width: '90%', maxWidth: '950px', height: '350px', perspective: '1200px' }}>
                  {testimonials.map((testimonial, index) => {
                    const total = testimonials.length;
                    const leftIndex = (currentIndex - 1 + total) % total;
                    const rightIndex = (currentIndex + 1) % total;
                    
                    let positionClass = '';
                    let style = {
                      position: 'absolute',
                      top: 0,
                      left: '50%',
                      width: '60%',
                      maxWidth: '550px',
                      transformOrigin: 'center center',
                      transformStyle: 'preserve-3d',
                      opacity: 0,
                      transition: 'all 0.8s ease-in-out',
                      filter: 'blur(8px)'
                    };
      
                    if (index === currentIndex) {
                      // Active/Center card
                      positionClass = 'z-30';
                      style = { ...style, opacity: 1, transform: 'translateX(-50%) scale(1) rotateY(0deg)', filter: 'none' };
                    } else if (index === leftIndex) {
                      // Left card
                      positionClass = 'z-20';
                      style = { ...style, opacity: 0.6, transform: 'translateX(-140%) scale(0.85) rotateY(25deg)', filter: 'blur(2px)' };
                    } else if (index === rightIndex) {
                      // Right card
                      positionClass = 'z-20';
                      style = { ...style, opacity: 0.6, transform: 'translateX(40%) scale(0.85) rotateY(-25deg)', filter: 'blur(2px)' };
                    }
      
                    return (
                      <div key={index} className={positionClass} style={style}>
                        {/* Sticky note container */}
                        <div className="bg-blue-300 rounded-2xl shadow-2xl p-8 relative" style={{ minHeight: '320px' }}>
                          {/* Quote frame border */}
                          <div className="absolute inset-4 border-3 border-black rounded-lg">
                            {/* Top quote */}
                            <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 text-5xl font-bold text-black">❝</div>
                            {/* Bottom quote */}
                            <div className="absolute -bottom-5 left-1/2 transform -translate-x-1/2 text-5xl font-bold text-black">❞</div>
                          </div>
      
                          {/* Polaroid photo with paper clip}
                          <div className="absolute -top-6 -right-4 bg-white p-2 shadow-xl z-20" style={{ width: '120px', transform: 'rotate(8deg)' }}>
                            {/* Paper clip 
                            <div className="absolute -top-3 right-3 w-6 h-8 border-2 border-gray-600 rounded-t-full" 
                                 style={{ borderBottom: 'none', transform: 'rotate(15deg)' }}>
                              <div className="absolute top-0 left-1/2 w-3 h-3 bg-gray-600 rounded-full transform -translate-x-1/2"></div>
                            </div>
                            
                            <img src={testimonial.image} alt={testimonial.name} className="w-full h-28 object-cover" />
                            <div className="bg-white pt-1 text-center">
                              <p className="text-xs text-gray-700">{testimonial.name}</p>
                            </div>
                          </div>
      
                          {/* Content */}
                          <div className="relative z-10 pt-6 px-4 h-full flex flex-col justify-center">
                            <p className="text-gray-900 text-base leading-snug mb-4 font-medium text-center mt-8">
                              {testimonial.text}
                            </p>
      
                            {/* Star rating */}
                            <div className="flex justify-center gap-1 mb-3 text-yellow-500">
                              ★★★★★
                            </div>
      
                            {/* Name and location */}
                            <div className="text-center">
                              <p className="text-sm text-gray-700">
                                <span className="font-bold">{testimonial.name}</span>
                                <br />
                                <span className="text-gray-500 text-xs">{testimonial.location}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
      
                  {/* Navigation Buttons */}
                  <div className="absolute left-1/2 transform -translate-x-1/2 flex gap-6 z-50" style={{ bottom: '-60px' }}>
                    <button
                      onClick={handlePrev}
                      className="bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-red-500 transition-colors duration-300"
                      style={{ width: '40px', height: '40px', border: 'none', cursor: 'pointer', fontSize: '18px' }}
                      aria-label="Previous testimonial"
                    >
                      &#10094;
                    </button>
                    <button
                      onClick={handleNext}
                      className="bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-red-500 transition-colors duration-300"
                      style={{ width: '40px', height: '40px', border: 'none', cursor: 'pointer', fontSize: '18px' }}
                      aria-label="Next testimonial"
                    >
                      &#10095;
                    </button>
                  </div>
                </div>
              </div>
            </section>

      {/* CTA Section */}
      <section className="py-16 bg-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl font-bold text-white mb-4">
              Ready to Secure Your Property?
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Get started with our property care services today and enjoy peace of mind 
              knowing your investment is in safe hands.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                onClick={toggleChatbot}
                className="bg-white text-primary-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
              >
                Request Service
              </Link>
              <Link
                to="/login"
                className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-primary-600 transition-colors"
              >
                Sign Up Now
              </Link>
              {isChatbotOpen && (
        <NriBuddyChatbot onClose={toggleChatbot} />
      )}
            </div>
          </motion.div>

        </div>
      </section>
    </div>
  );
};

export default PropertyCare;